import type { ChangelogEntry } from "../types";

/** CRM fase 2: Salgsmuligheter med oppfølgingskø, pipe, regler, varsler, tilbud fra prosess og mailutkast. */
export const CRM_FASE_2_SALGSMULIGHETER_2026_10: ChangelogEntry = {
  id: "2026-10-17-crm-fase-2-salgsmuligheter",
  date: "2026-10-17",
  title: "Salgsmuligheter: oppfølgingskø og pipe",
  summary:
    "Ny side for salgsarbeidet. Køen gir deg én oppfølging om gangen med fire utfall, pipen viser alle prosesser fra første kontakt til tilbud, og kundekortet viser neste steg og verdien i pipen.",
  sections: [
    {
      heading: "Oppfølgingskøen",
      items: [
        {
          title: "Din uke og køen",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "Under «Salgsmuligheter» ser du ukens fremdrift og én oppfølging om gangen med årsak, siste kontakt og åpne prosesser. Velg «Se mailutkast», «Tok det på tlf», «Utsett» eller «Avslutt», eller bruk tastene 1 til 4. Etter e-post eller samtale lagrer du neste steg, og først da lukkes oppfølgingen.",
        },
        {
          title: "Oppfølginger lages av regler",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "Hver hverdag morgen lager sju regler oppfølginger, for eksempel når et tilbud står uten svar i sju dager eller en varm kunde er i ferd med å kjølne. Du får varsel når kunden svarer og om morgenen når du har oppfølginger som forfaller.",
        },
        {
          title: "Mailutkast i Sølvrev-tone",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "«Lag utkast» og «Foreslå svar» i e-postdialogen skriver et forslag du kan redigere. Utkastet sendes aldri av seg selv.",
        },
      ],
    },
    {
      heading: "Pipen og kundekortet",
      items: [
        {
          title: "Pipe med prosesser",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "Dra prosesser mellom Outreach og Møte, lag tilbud direkte fra en prosess, og marker tapt med årsak. Prosesser som står stille blir rødmerket.",
        },
        {
          title: "Neste steg, prosesser og verdi i pipe på kundekortet",
          kind: "nytt",
          featureFlag: "feature_crm_ko_pipe",
          body: "Kundekortet viser kundens oppfølginger gruppert på prioritet, åpne prosesser med «Ny prosess» og «Lag tilbud», og et femte nøkkeltall med vektet verdi i pipen.",
        },
      ],
    },
  ],
};
